import * as React from 'react';
import styled from 'styled-components';
import logoWithName from '../../assets/sunbit-logo-white-text.svg';

// ############################ Styles ###########################
// tslint:disable:variable-name

const SPoweredByContainer = styled.div(
  ({ theme }) => `
    width: 100%;
    background-color: ${theme.colors.primaryBackground};
    box-sizing: border-box;
    padding: ${theme.spacing.huge}px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: ${theme.spacing.huge}px;
  }
    `,
);
const SPoweredByBox = styled.div(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  font-size: ${theme.font.size.small};
  color: ${theme.colors.gray};
`,
);

const SLink = styled.a(
  ({ theme }) => `
  display: block;
  color: ${theme.colors.white};
  font-size: ${theme.font.size.smallMedium};
  font-weight: ${theme.font.weight.medium};
  margin: ${theme.spacing.large}px;
  text-align: center;
`,
);

const SpoweredByLogoImage = styled.img(
  ({ theme }) => `
  width: 158px;
  height: 45px;
  padding: 0;
  padding-bottom: 30px;

  @media only screen and ${theme.device.max.mobileM} {
    width: 230px;
    height: 65px;
  }
    `,
);

// tslint:enable:variable-name
// ############################ End Styles ###########################

export interface IPoweredByProps {
  privacyPolicyUrl: string;
  termsOfUseUrl: string;
}

interface IPoweredByState {
}

export default class PoweredBy extends React.Component<IPoweredByProps, IPoweredByState> {
  public render() {

    return (
      <SPoweredByContainer>
        <SPoweredByBox>
          {/* eslint-disable-next-line react/jsx-no-target-blank */}
          <a href="http://sunbit.com/" target="_blank" rel="noreferrer">
            <SpoweredByLogoImage src={logoWithName} alt="Sunbit Logo" />
          </a>
          <SLink data-at="howItWorks" key="howItWorks" href="https://sunbit.com/how-it-works/">About us</SLink>
          <SLink data-at="privacyPolicyLinkNoNavigation" key="privacyPolicy" href={this.props.privacyPolicyUrl} target="_blank">
            Privacy Policy
          </SLink>
          <SLink data-at="termsOfUseLinkNoNavigation" key="termsOfUse" href={this.props.termsOfUseUrl} target="_blank">
            Terms of service
          </SLink>
        </SPoweredByBox>
      </SPoweredByContainer>
    );
  }
}
